<template>
  <div id="app" class="app-content mb-4">
    <app-header></app-header>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <b-card-group deck>
            <HelpMenu></HelpMenu>
            <FAQSection></FAQSection>
            <MainBalance></MainBalance>
          </b-card-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "../reuseable_components/Header.vue";
import HelpMenu from "./HelpMenu.vue";
import FAQSection from "./FAQSection.vue";
import MainBalance from "./MainBalance.vue";

export default {
  name: "FAQ",
  components: {
    "app-header": AppHeader,
    HelpMenu: HelpMenu,
    FAQSection: FAQSection,
    MainBalance: MainBalance,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>
